import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DateRange } from "@/lib/date";
import { ProductInsights } from "@/components/admin/product-analytics/ProductInsights";
import { ProductComparison } from "@/components/admin/product-analytics/ProductComparison";
import { ProductOverview } from "@/components/admin/product-analytics/ProductOverview";
import { ProductUsage } from "@/components/admin/product-analytics/ProductUsage";

export function DetailedProductAnalytics({
  productId,
  dateRange,
}: {
  productId: string;
  dateRange: DateRange;
}) {
  return (
    <Tabs defaultValue="overview">
      <TabsList className="mb-4">
        <TabsTrigger value="overview">Overview</TabsTrigger>
        <TabsTrigger value="usage">Usage Analysis</TabsTrigger>
        <TabsTrigger value="comparison">Product Comparison</TabsTrigger>
        <TabsTrigger value="insights">Insights</TabsTrigger>
      </TabsList>

      <TabsContent value="overview">
        <ProductOverview productId={productId} dateRange={dateRange} />
      </TabsContent>

      <TabsContent value="usage">
        <ProductUsage productId={productId} dateRange={dateRange} />
      </TabsContent>

      <TabsContent value="comparison">
        <ProductComparison productId={productId} dateRange={dateRange} />
      </TabsContent>

      <TabsContent value="insights">
        <ProductInsights />
      </TabsContent>
    </Tabs>
  );
}
